// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "-legacy." + {"132":"3e5bc5eb","354":"024f89c5","368":"d32d88ed","399":"683fdc44","624":"88b5c856","738":"4eea6023","838":"3787910e"}[chunkId] + ".js";
};